import {
  Component,
  ElementRef,
  EventEmitter, HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ProductType } from 'src/app/shared-lib/domains/product';
import { CartService } from "../../shared/cart.service";

@Component({
  selector: "app-mobile-home-summary",
  templateUrl: "./mobile-home-summary.component.html",
  styleUrls: ["./mobile-home-summary.component.scss"],
  standalone: false
})
export class MobileHomeSummaryComponent implements OnInit {
  @Input() printProduct;
  @Input() cartTotal;
  @Input() isLoading;
  @Output() addingFiles = new EventEmitter<any>();
  @ViewChild("knob") knob: ElementRef<HTMLDivElement>;
  @ViewChild("overlay") overlay: ElementRef<HTMLDivElement>;
  collapsed = true;
  isDragging = false;


  @HostListener('window:mousemove', ['$event'])
  onWindowMouseMove(event: MouseEvent) {
    // Llama a tu función onDrag original
    // onDrag ya comprueba internamente si isDragging es true
    this.onDrag(event);
  }

  @HostListener('window:touchmove', ['$event'])
  onWindowTouchMove(event: TouchEvent) {
    // Llama a tu función onDrag original
    this.onDrag(event);
  }

  @HostListener('window:mouseup')
  onWindowMouseUp() {
    // Llama a checkEnd solo si estábamos arrastrando
    if (this.isDragging) {
      this.checkEnd();
    }
  }

  @HostListener('window:touchend')
  onWindowTouchEnd() {
    // Llama a checkEnd solo si estábamos arrastrando
    if (this.isDragging) {
      this.checkEnd();
    }
  }

  constructor(public cartService: CartService) { }

  ngOnInit() { }

  shouldAllowClick = () => {
    return !!this.printGroupItems().length && !this.isLoading;
  };

  printGroupItems() {
    return this.cartService.cart.items.filter(
      (item) => item.product.type === ProductType.PRINT && !item.product.vendor
    );
  }

  startDragging(event: TouchEvent | MouseEvent) {
    this.isDragging = true;
  }

  get filesAlreadyAdded() {
    return this.printProduct.product.printingGroup?.files.length || false;
  }

  onDrag(event: TouchEvent | MouseEvent) {
    if (this.isDragging) {
      let clientX;
      if (event instanceof TouchEvent) {
        clientX = event.touches[0].clientX;
      } else {
        clientX = (event as MouseEvent).clientX;
      }
      const trackRect =
        this.knob.nativeElement.parentElement.getBoundingClientRect();
      let newLeft =
        clientX - trackRect.left - this.knob.nativeElement.offsetWidth / 2;
      newLeft = Math.max(
        0,
        Math.min(
          newLeft,
          trackRect.width - this.knob.nativeElement.offsetWidth - 10
        )
      );
      this.knob.nativeElement.style.left = `${newLeft}px`;
      this.overlay.nativeElement.style.width = `${newLeft + this.knob.nativeElement.offsetWidth / 2
        }px`;
    }
  }

  checkEnd() {
    this.isDragging = false;
    const knobRect = this.knob.nativeElement.getBoundingClientRect();
    const trackRect =
      this.knob.nativeElement.parentElement.getBoundingClientRect();

    if (knobRect.right >= trackRect.right - 20) {
      this.cartService.goToCart();
    }

    this.knob.nativeElement.style.left = "0";
    this.overlay.nativeElement.style.width = "0";
  }

  addingFilesEvent() {
    this.addingFiles.emit();
  }
}
